import Images from "../images";
const prompts = [
  {
    text: "Popular Majors",
    message: "What are the most popular majors in Malaysia?",
    icon: Images.VisionAIPopularMajors,
    prompt: "Popular Majors",
    gradient: "bg-gradient-to-b from-[#F65BF8] to-[#F1ACFA]",
  },
  {
    text: "Malaysia Visa Requirements",
    message: "How do I apply for a student visa in Malaysia?",
    icon: Images.VisionAIVisaReq,
    prompt: "Malaysia Visa Requirements",
    gradient: "bg-gradient-to-b from-[#0AD1E9] to-[#87E2F8]",
  },
  {
    text: "Scholarship Options",
    message:
      "What are the scholarship opportunities for international students?",
    icon: Images.VisionAIScholarshipOptions,
    prompt: "Scholarship Options",
    gradient: "bg-gradient-to-b from-[#36E978] to-[#95F89D]",
  },
  {
    text: "Top Malaysian Universities",
    message: "What are the top universities in Malaysia?",
    icon: Images.VisionAITopMyUni,
    prompt: "Top Malaysian Universities",
    gradient: "bg-gradient-to-b from-[#FF7B46] to-[#FDB889]",
  },
  {
    text: "International Student Guide",
    message: "What is the cost of living for a student in Malaysia?",
    icon: Images.VisionAIIntlStuGuide,
    prompt: "International Student Guide",
    gradient: "bg-gradient-to-b from-[#6275F8] to-[#9298F9]",
  },
];

export default prompts;
